import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type GhostModeState = {
    inGhostMode: boolean;
};

const initialState: GhostModeState = {
    inGhostMode: false,
};

export const ghostModeSlice = createSlice({
    name: 'ghostMode',
    initialState,
    reducers: {
        setGhostMode(state, action: PayloadAction<boolean>) {
            state.inGhostMode = action.payload;
        },
    },
});

export const { setGhostMode } = ghostModeSlice.actions;
export const selectInGhostMode = (state: { ghostMode?: GhostModeState }) => state.ghostMode?.inGhostMode ?? false;
